import React, { useEffect, useState } from "react";
import { Http } from '../../../../../Core/Services/HttpService';
import Select from "react-select";
import '../../misreport.scss';
import { BsChevronDoubleLeft, BsChevronDoubleRight, BsChevronCompactLeft, BsChevronCompactRight } from "react-icons/bs";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { AiOutlineFilePdf, AiOutlineFileExcel, AiOutlineSearch } from "react-icons/ai";

type PropsItems = {
    year: any;
    nodalAgency: any;
};

const GrantReleasedDiscomReports = ({ year, nodalAgency }: PropsItems) => {

    const [fundReleasedData, setFundReleasedData] = useState<any>();
    const [selectedDiscom, setSelectedDiscom] = useState<any>(0);
    const [reportType, setReportType] = useState<any>('Discom');
    const [exportData, setexportData] = useState<any>('');
    const [misReportDataCount, setMisReportDataCount] = useState<any>(0);
    const [searchText, setSearchText] = useState('');
    const [_discomid, setDiscomid] = useState<any>(0);
    const [backlink, setBackLink] = useState<any>(null);
    const [discomList, setDiscomList] = useState([{ 'id': 0, 'discom_name': 'All' }]);
    const [selectedDiscomValue, setSelectedDiscomValue] = useState<any>(0);

    const location = useLocation();
    let navigate = useNavigate();

    // For pagination
    const [currentPage, setCurrentPage] = useState<any>(0);
    const [pageSize, setPageSize] = useState(10);
    const [totalItems, setTotalItems] = useState(0);
    const [pageCount, setPageCount] = useState(0);
    const [totalPages, setTotalPages] = useState<any>(0);
    const [first, setFirst] = useState(1);
    const [last, setLast] = useState(pageSize);
    const [pageInput, setPageInput] = useState(1);
    const [amountTotal, setAmountTotal] = useState<any>(0);
    const [amountGrandTotal, setAmountGrandTotal] = useState<any>(0);

    const handleDiscomSelect = (selectedDiscom: any) => {
        setCurrentPage(0);
        setSelectedDiscom(selectedDiscom);
        setSelectedDiscomValue(selectedDiscom.value);
    }

    const handleFirstClick = () => {
        setCurrentPage(1);
        setFirst(1);
        setLast(pageSize);
    };

    const handleLastClick = () => {
        setCurrentPage(totalPages);
        setFirst((totalPages - 1) * pageSize + 1);
        setLast(totalPages * pageSize);
    };

    const fetchDiscomData = async () => {
        if (year && nodalAgency) {
            await Http.get("/apiv1/report-sm-nodel-discom-list/?nodal_agency=" + nodalAgency)
                .then((res) => {
                    setDiscomList(res.discomList);
                }).catch((e) => {
                    console.log(e);
                });
        }
    }

    useEffect(() => {
        fetchDiscomData();
    }, [year, nodalAgency])

    useEffect(() => {
        setSelectedDiscom(0);
    }, [])

    const handlePageChange = (event: any) => {
        if (isNaN(event.target.value)) {
            setPageInput(1);
            setCurrentPage(1);
            setFirst(1);
            setLast(pageSize);
        } else {
            if (event.target.value > totalPages) {
                setPageInput(totalPages);
                setCurrentPage(totalPages);
            } else if (event.target.value < 1) {
                setPageInput(1);
                setCurrentPage(1);
            } else {
                setPageInput(event.target.value);
                setCurrentPage(event.target.value);
            }
        }
    };

    const handleGoClick = (e: any) => {
        if (e.keyCode === 13) {
            const pageNumber = pageInput;
            if (pageNumber >= 1 && pageNumber <= totalPages) {
                setCurrentPage(pageNumber);
                setFirst((pageNumber - 1) * pageSize + 1);
                setLast(Math.min(totalItems, pageNumber * pageSize));
            }
        }
    };

    const handleSearchTextChange = (event: any) => {
        setSearchText(event.target.value);
    }

    useEffect(() => {
        (async () => {
            if (location.state) {
                setDiscomid(location.state.discomid);
            } else {
                navigate('/nodal-view');
            }
        })();
    }, []);

    const handleSearchEnter = (event: any) => {
        if (event.key === 'Enter') {
            fetchFundReleasedData();
        }
    }

    const fetchFundReleasedData = async () => {
        const curPage = (currentPage != 0) ? currentPage - 1 : 0;
        await Http.get('/apiv1/report-sm-gr-discom-data?form_id=184&year=' + year + '&nodal_agency=' + nodalAgency + '&discomid=' + selectedDiscomValue + '&searchtext=' + searchText + '&page=' + curPage + '&pageSize=' + pageSize)
            .then((res) => {
                setMisReportDataCount(res.fundReleasedData.length);
                setFundReleasedData(res.fundReleasedData);
                setTotalItems(res.totalRecord);
                setPageCount(Math.ceil(res.totalRecord / pageSize));
                setTotalPages(Math.ceil(res.totalRecord / pageSize));
                setAmountTotal(res.sm_amount_total);
                setAmountGrandTotal(res.sm_amount_grand_total);

                let cPage = (!currentPage) ? 1 : currentPage;
                setFirst((cPage - 1) * pageSize + 1);
                setLast(Math.min(res.totalRecord, cPage * pageSize));

            }).catch((e) => {
                console.log(e);
            });
    }

    useEffect(() => {
        if (year && nodalAgency) {
            fetchFundReleasedData();
        }
    }, [year, nodalAgency])

    useEffect(() => {
        if (currentPage != 0) {
            fetchFundReleasedData();
        }
    }, [currentPage, searchText]);

    function toFixed(amt: any, decimal: number = 0) {
        amt = `${amt}`;
        let hasCondition = amt.includes("mark");
        if (hasCondition) {
            amt = amt.replace(/<\/?[^>]+(>|$)/g, "");
        }
        amt = (amt + "").replace(/[^\-.0-9]+/g, '');
        if (amt == '') amt = decimal == 0 ? 0 : "0.00";

        amt = new Intl.NumberFormat("en-IN", {
            minimumFractionDigits: decimal,
            maximumFractionDigits: decimal,
        }).format(amt);
        if (hasCondition) {
            amt = "<mark class='d-inline-block'>" + amt + "</mark>";
        }
        return amt;
    }


    const back = () => {
        setBackLink('/nodal-view#FundReleased');
    }

    useEffect(() => {
        (async () => {
            if (backlink) {
                navigate(backlink, { state: { discomid: _discomid, module_type: 'SmartMetering', module_sub_type: 'SmGrantReleased' } });
            }
        })();
    }, [backlink]);

    return (
        <>
            <div className="container mb-5 mt-4">
                <div className="dashboardInner detailedDashboard">
                    <div className="row gx-xxl-5">
                        <div className="col-xxl-12 col-xl-12">
                            <div className="heading mb-2">
                                <div className="row align-items-center">
                                    <div className="col-md-12 d-flex align-items-center justify-content-between">
                                        <h4 className="mb-0">Fund Released Reports - Smart Metering - Grant Released - Discom</h4>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row align-items-center">
                    <div className="col-md-4">
                        <div className="">
                            <label htmlFor="discom" className="form-label">Select Discom</label>
                            <Select id="discom" className="misReportSelect" aria-label="Discom" onChange={handleDiscomSelect} isSearchable={true} options={discomList} value={selectedDiscom} />
                        </div>
                    </div>
                    <div className="col-md-8 text-center search-hover">
                        <div className="d-flex justify-content-between align-items-center misBottomBtn">
                            <button className="bsSearchBtn" onClick={fetchFundReleasedData}><AiOutlineSearch className="pl-3 mb-0 h5 text-light" /></button>
                            <div className="dIcnBtn">
                                <a target="_blank" href={process.env.REACT_APP_API_ENDPOINT + '/apiv1/report-sm-gr-discom-data?form_id=184&year=' + year + '&nodal_agency=' + nodalAgency + '&discomid=' + selectedDiscomValue + '&reportType=' + reportType + '&searchtext=' + searchText + '&task=excel'}><AiOutlineFileExcel className="pl-3 mb-0 h5 text-info" /></a>
                                <a target="_blank" href={process.env.REACT_APP_API_ENDPOINT + '/apiv1/report-sm-gr-discom-data?form_id=184&year=' + year + '&nodal_agency=' + nodalAgency + '&discomid=' + selectedDiscomValue + '&reportType=' + reportType + '&searchtext=' + searchText + '&task=pdf'}><AiOutlineFilePdf className="pl-3 mb-0 h5 text-warning" /></a>
                            </div>
                        </div>
                    </div>
                </div>
                <section className="financialForm misNew">
                    <div className="mt-4">
                        <div>Displaying {first} to {last} of {totalItems}</div>
                        <div className="mt-2 financialMainFrom misReportTable">
                            <div className="tab-content p-0 border-0">
                                <div className="table-responsive RevenueDetailsTable misreportTable">
                                    <table className="table">
                                        <thead>
                                            <tr className="text-center">
                                                <th scope="col" className="text-start">Sr. No</th>
                                                <th scope="col">Name of Discom</th>
                                                <th scope="Item Summary">Tranche</th>
                                                <th scope="col">Sanction No.</th>
                                                <th scope="col">Sanction Date</th>
                                                <th scope="col">Amount (INR)</th>
                                                <th scope="col">Date of Release</th>
                                                <th scope="col">Remarks</th>
                                                <th scope="col">Update By</th>
                                                <th scope="col">Update Date/Time</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {misReportDataCount > 0 && fundReleasedData.length > 0 ? fundReleasedData.map((releasedData: any, index: any) => {
                                                return <tr>
                                                    <td>{index + 1}</td>
                                                    <td dangerouslySetInnerHTML={{ __html: releasedData.sm_gr_discom_id }}></td>
                                                    <td dangerouslySetInnerHTML={{ __html: releasedData.sm_gr_tranche }}></td>
                                                    <td dangerouslySetInnerHTML={{ __html: releasedData.sm_gr_sanction_no }}></td>
                                                    <td dangerouslySetInnerHTML={{ __html: releasedData.sm_gr_sanction_date }}></td>
                                                    <td dangerouslySetInnerHTML={{ __html: toFixed(releasedData.sm_gr_amount, 2) }}></td>
                                                    <td dangerouslySetInnerHTML={{ __html: releasedData.sm_gr_date_of_release }}></td>
                                                    <td dangerouslySetInnerHTML={{ __html: releasedData.sm_gr_remarks }}></td>
                                                    <td dangerouslySetInnerHTML={{ __html: releasedData.sm_gr_update_by }}></td>
                                                    <td dangerouslySetInnerHTML={{ __html: releasedData.sm_gr_update_date }}></td>
                                                </tr>
                                            }) : <tr><td colSpan={10} className="text-center my-5"><h5>No Record Found</h5></td></tr>}

                                            {misReportDataCount > 0 && fundReleasedData.length > 0 ?
                                                <>
                                                    {/* <tr>
                                                        <td colSpan={4} className="text-center">Total</td>
                                                        <td className="text-center">{toFixed(amountTotal,2)}</td>
                                                        <td className="text-center">&nbsp;</td>
                                                        <td className="text-center">&nbsp;</td>
                                                    </tr> */}
                                                    <tr>
                                                        <td colSpan={5} className="text-center"><strong>Grand Total</strong></td>
                                                        <td className="text-center"><strong>{toFixed(amountGrandTotal,2)}</strong></td>
                                                        <td className="text-center">&nbsp;</td>
                                                        <td className="text-center">&nbsp;</td>
                                                    </tr>
                                                </>
                                                : null
                                            }
                                        </tbody>
                                    </table>
                                </div>
                                {totalItems != 0 ?
                                    <div className="mt-3">
                                        <nav aria-label="Page navigation g-3 d-flex justify-content-center">
                                            <ul className="pagination justify-content-center">
                                                <li className="page-item">
                                                    <button className="page-link" onClick={handleFirstClick} disabled={(currentPage === 1 || currentPage === 0)}>
                                                        <BsChevronDoubleLeft />
                                                    </button>
                                                </li>
                                                <li className="page-item">
                                                    <button className="page-link" onClick={() => setCurrentPage(parseInt(currentPage) - 1)} disabled={(currentPage === 1 || currentPage === 0)}>
                                                        <BsChevronCompactLeft />
                                                    </button>
                                                </li>
                                                <li className="page-item col-1">
                                                    <input type="input" className="form-control" value={(currentPage === 0) ? parseInt(currentPage) + 1 : currentPage} onChange={handlePageChange} onKeyDown={handleGoClick}></input>
                                                </li>
                                                <li className="page-item">
                                                    <button className="page-link" onClick={() => setCurrentPage((currentPage === 0 ? parseInt(currentPage) + 1 : parseInt(currentPage)) + 1)} disabled={currentPage === totalPages}>
                                                        <BsChevronCompactRight />
                                                    </button>
                                                </li>
                                                <li className="page-item">
                                                    <button className="page-link" onClick={handleLastClick} disabled={currentPage === totalPages}>
                                                        <BsChevronDoubleRight />
                                                    </button>
                                                </li>
                                                {/* <li className="page-item">
                                                <span>
                                                    Page {currentPage} of {totalPages}. Showing {first} to {last} of {totalItems} entries.
                                                </span>
                                                <span>
                                                    Go to page: <input className="form-control" type="text" value={pageInput} onChange={handlePageChange} />
                                                    <button className="page-link" onClick={handleGoClick}>Go</button>
                                                </span>
                                            </li> */}
                                            </ul>
                                        </nav>
                                        <div className="page-item text-center">
                                            <span>
                                                Page {(currentPage === 0) ? parseInt(currentPage) + 1 : currentPage} of {totalPages}
                                            </span>
                                        </div>
                                    </div>
                                    :
                                    null
                                }
                            </div>
                        </div>
                    </div>
                </section>
                <div className="formBtnSection justify-content-end mt-4">
                    <Link to="#" className="btn btnSubmit me-4" onClick={() => back()}>Back</Link>
                </div>
            </div>
        </>
    );
}

export default GrantReleasedDiscomReports;